module.exports = __webpack_public_path__ + "img/ix20.68f8c069.png";